import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetAdministrationSheets from "services/recordSheets/useGetAdministrationSheets";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetSection, SheetGrid, SheetField, SheetDiagnosisField, formatText, formatBoolean } from "../SheetLayout";

const EntornoTrabajador: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const parteId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { dataAdministrationSheet: d, loadingAdministrationSheet, errorAdministrationSheet, getWorkerEnvironment } = useGetAdministrationSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getWorkerEnvironment(userId, prestacionId, parteId); }, []);

  if (loadingAdministrationSheet) return <section className="container"><LoaderMin /></section>;
  if (errorAdministrationSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero title="Entorno Trabajador" icon="users" />

      <SheetSection title="Domicilio" icon="pin">
        <SheetGrid>
          <SheetField
            label="Domicilio completo"
            value={`${d.dompf_type_street_description || ""} ${d.dompf_street || ""}, ${d.dompf_number || ""}`.trim()}
            wide
          />
          <SheetDiagnosisField label="Tipo Vía"    code={d.dompf_type_street_code || ""} desc={d.dompf_type_street_description || ""} />
          <SheetField     label="Nombre Vía"  value={formatText(d.dompf_street)} />
          <SheetField     label="Código Postal" value={formatText(d.postal_code)} />
          <SheetDiagnosisField label="Código Localidad" code={d.dompf_city_code || ""} desc="" />
          <SheetField     label="Provincia"   value={formatText(d.province_description)} />
          <SheetField     label="Número"      value={formatText(d.dompf_number)} />
          <SheetField     label="BIS"         value={formatText(d.dompf_bis_number)} />
          <SheetField     label="Bloque"      value={formatText(d.dompf_block)} />
          <SheetField     label="Escalera"    value={formatText(d.dompf_stairs)} />
          <SheetField     label="Piso"        value={formatText(d.dompf_floor)} />
          <SheetField     label="Puerta"      value={formatText(d.dompf_door)} />
          <SheetField     label="Domicilio Extranjero" value={formatBoolean(d.is_dompf_type)} />
          {d.is_dompf_type && <>
            <SheetField label="Dirección Extranjero" value={formatText(d.foreign_address)} />
            <SheetField label="Localidad Extranjero" value={formatText(d.foreign_location)} />
            <SheetField label="País Extranjero"      value={formatText(d.foreign_country)} />
          </>}
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Datos de contacto" icon="phone">
        <SheetGrid>
          <SheetField label="Teléfono"        value={formatText(d.phone)} />
          <SheetField label="Teléfono Móvil"  value={formatText(d.movil)} />
          <SheetField label="Teléfono Móvil 2" value={formatText(d.movil2)} />
          <SheetField label="Fax"             value={formatText(d.fax)} />
          <SheetField label="Email"           value={formatText(d.email)} />
          <SheetField label="Cuenta Bancaria" value={formatText(d.bank_account)} />
        </SheetGrid>
      </SheetSection>
    </SheetPage>
  );
};

export default EntornoTrabajador;
